// Valid crew epkRole values for the fepk schema.
// "lead_actor" and "supporting_actor" are cast roles and handled separately.
export const CREW_EPK_ROLES = [
  "director",
  "producer",
  "cinematographer",
  "editor",
  "writer",
  "sound",
  "filmmaker",
];

// Maps a User.role (account role) to a valid crew epkRole enum value.
// Returns null when the role is not a crew role (e.g. Admin, Actor, Viewer).
export const toCrewEpkRole = (role) => {
  if (!role) return null;
  const normalized = role.toLowerCase().replace(/ /g, "_");
  return CREW_EPK_ROLES.includes(normalized) ? normalized : null;
};

// Returns true when a user's account role qualifies them to be added as
// cast (actor) or crew on an EPK. Non-industry roles (Admin, Sales Agent,
// Distributor, Film Festival, Viewer, Investor, Industry Professional,
// or no role) return false.
export const canJoinCastOrCrew = (user) => {
  if (!user || !user.role) return false;
  const roleLower = user.role.toLowerCase();
  if (roleLower.includes("actor")) return true;
  return toCrewEpkRole(user.role) !== null;
};
